import { useState } from "react";
import { User } from "lucide-react";
import type { Profile } from "../../../types";
import { AppHeader } from "../AppHeader";
import { AppHero } from "../AppHero";
import { BrandedLoading } from "../BrandedLoading";
import { ProfileForm } from "./ProfileForm";

export function ProfileEditorScreen({
  mode,
  profile,
  loading = false,
  onSubmit,
  createSubmitLabel = "Next",
}: {
  mode: "create" | "edit";
  profile?: Partial<Profile>;
  loading?: boolean;
  onSubmit: (profile: Partial<Profile>, photos: File[]) => Promise<void>;
  createSubmitLabel?: string;
}) {
  const [dirty, setDirty] = useState(false);
  const [saving, setSaving] = useState(false);

  if (mode === "create") {
    return (
      <>
        <AppHeader title="Create Profile" mobileHidden desktopHidden />
        {loading ? (
          <BrandedLoading message="Loading your profile" />
        ) : (
          <>
            <AppHero
              eyebrow="Step 1 of 2"
              title="Build your profile"
              description="Photos and details help Yara introduce you with care."
              icon={User}
              className="settings-sub-hero"
            />
            <ProfileForm
              onboardingStep="profile"
              initial={profile}
              submitLabel={createSubmitLabel}
              onSubmit={onSubmit}
            />
          </>
        )}
      </>
    );
  }

  return (
    <>
      <AppHeader
        title="Edit Profile"
        backTo="/settings"
        trailing={dirty ? (
          <button className="screen-header-action" type="submit" form="profile-form" disabled={saving}>
            {saving ? "Saving…" : "Save"}
          </button>
        ) : undefined}
      />
      <ProfileForm
        variant="edit"
        initial={profile}
        submitLabel="Save Changes"
        onDirtyChange={setDirty}
        onSavingChange={setSaving}
        onSubmit={onSubmit}
      />
    </>
  );
}
